export default "__VITE_ASSET__BhRK9tk2__"